import { Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSnackbar } from 'notistack';

// `icon` shows an X (e.g. the Slack result snackbars, per design) instead of the "Dismiss" text button.
const NotificationDismissButton = function ({ notificationId, icon = false }) {
    const { closeSnackbar } = useSnackbar();
    if (icon) {
        return (
            <IconButton aria-label="close" color="inherit" size="small" onClick={() => closeSnackbar(notificationId)}>
                <CloseIcon fontSize="small" />
            </IconButton>
        );
    }
    return (
        <Button color="warning" onClick={() => closeSnackbar(notificationId)}>
            Dismiss
        </Button>
    );
};

export default NotificationDismissButton;
